

import mixx from '../../../../mixin/mixin.js'


export default {
  mixins: [mixx],
  name: "tventas",
  data() {
    return {
      loading: false,
      loading_f: false,
      tbv: null,
      tbv2: null,
      ventas: [],

      comercios_f: [],

      f_c: {
        desde: this.date_rest(this.currentdate(), -14),
        hasta: this.currentdate(),
      }

    };
  },

  computed: {
    reporte: function () {
      return '/SERVER/scd/excel/?dsis='+window.sssdi+'&a=cupliqDett' + '&desde=' + this.f_c.desde + '&hasta=' + this.f_c.hasta
    }
  },

  mounted: function () {

    this.tbv = $('#ventas').DataTable({
      'paging': true,
      'lengthChange': true,
      'searching': true,
      'ordering': true,
      'info': true,
      "order": [],
      'autoWidth': true,
      orderCellsTop: true,
      fixedHeader: true

    });



    $('.box').boxWidget();

    //this.consultar();

  },

  methods: {
    consultar() {
      this.loading = true;

      this.tbv.clear();

      this.$http
        .post('/SERVER/scd/reportes/', {
          'a': 'cupliqDett',
          'f': this.f_c
        }, {
          withCredentials: true
        })
        .then(response => {

          if (response.data.status == 1) {

            for (let i = 0; i < response.data.data.length; i++) {

              response.data.data[i][12] = this.num_to_many(response.data.data[i][12]);
              response.data.data[i][14] = this.num_to_many(response.data.data[i][14]);
              response.data.data[i][15] = this.num_to_many(response.data.data[i][15]);
              response.data.data[i][16] = this.num_to_many(response.data.data[i][16]);
              response.data.data[i][17] = this.num_to_many(response.data.data[i][17]);
              response.data.data[i][18] = this.num_to_many(response.data.data[i][18]);
              response.data.data[i][19] = this.num_to_many(response.data.data[i][19]);
              response.data.data[i][20] = this.num_to_many(response.data.data[i][20]);
              response.data.data[i][21] = this.num_to_many(response.data.data[i][21]);


              this.tbv.row.add(response.data.data[i]);

            }

          }
          this.tbv.draw();

          this.loading = false;
        });

    },

  }


};



// WEBPACK FOOTER //
// ./src/components/reportes/cuponesLiqDet/tventas/tventas.js